export default __webpack_public_path__ + "static/media/play_overlay.d59c1c11.svg";